(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wce-carousel-content"] && !Shopify.designMode) return;
  try {
    /**
   * Keeps the WCE carousel on its first card until the visitor interacts with it.
   *
   * WebKit (iOS Safari/Chrome) re-evaluates mandatory scroll-snap when the slides' layout
   * changes (e.g. lazy card images loading as the carousel scrolls into view) and can
   * re-snap to a later card on its own. No script moves it, so we can't stop the cause;
   * instead, any scroll that happens before the first interaction is put back on card 1.
   * The guard removes itself after the first interaction, or once the carousel has been on
   * screen for 1.5s, so it never fights the visitor or assistive tech.
   * Not rendered in the theme editor, where block selection scrolls cards deliberately.
   * See docs/components/wce-carousel.md §7.
   */
  class WceCarouselGuard extends HTMLElement {
    /** How long the carousel must stay on screen before WebKit's re-snap window is over. */
    static SETTLE_MS = 1500;

    /** @type {AbortController | null} */
    #controller = null;

    /** @type {IntersectionObserver | null} */
    #observer = null;

    /** @type {number | undefined} */
    #settleTimer;

    connectedCallback() {
      const wrapper = this.closest('.wce-carousel-wrapper');
      const scroller = wrapper?.querySelector('slideshow-slides');

      if (!wrapper || !scroller) return;

      this.#controller = new AbortController();
      const { signal } = this.#controller;
      const options = { capture: true, passive: true, signal };
      const release = () => this.#release();

      // A vertical page scroll that starts on a card is not an interaction with the carousel,
      // so touches only count once they move sideways. Everything else counts straight away
      // (click covers the dots: it runs before their scroll starts).
      for (const type of ['click', 'keydown', 'focusin']) {
        wrapper.addEventListener(type, release, options);
      }

      wrapper.addEventListener(
        'pointerdown',
        (event) => {
          if (event.pointerType !== 'touch') release();
        },
        options
      );

      wrapper.addEventListener(
        'wheel',
        (event) => {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) release();
        },
        options
      );

      let touchStart = { x: 0, y: 0 };

      wrapper.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.touches[0];
          if (touch) touchStart = { x: touch.clientX, y: touch.clientY };
        },
        options
      );

      wrapper.addEventListener(
        'touchmove',
        (event) => {
          const touch = event.touches[0];
          if (!touch) return;

          const dx = Math.abs(touch.clientX - touchStart.x);
          const dy = Math.abs(touch.clientY - touchStart.y);

          if (dx > 10 && dx > dy) release();
        },
        options
      );

      const resetToFirstCard = () => {
        if (scroller.scrollLeft === 0) return;

        // Horizon's slideshow syncs its current index and dots from this scroll.
        scroller.scrollTo({ left: 0, behavior: 'instant' });
      };

      scroller.addEventListener('scroll', resetToFirstCard, { passive: true, signal });
      resetToFirstCard();

      // The re-snap happens as the carousel comes into view. Once it has stayed on screen for
      // SETTLE_MS, stand down so later native scrolls (VoiceOver moving to a card, find-in-page)
      // are never undone. The timer restarts if the carousel leaves the screen before settling.
      this.#observer = new IntersectionObserver(
        ([entry]) => {
          clearTimeout(this.#settleTimer);

          if (entry?.isIntersecting) {
            this.#settleTimer = setTimeout(() => this.#release(), WceCarouselGuard.SETTLE_MS);
          }
        },
        { threshold: 0.5 }
      );
      this.#observer.observe(scroller);
    }

    disconnectedCallback() {
      this.#release();
    }

    #release() {
      this.#controller?.abort();
      this.#controller = null;
      this.#observer?.disconnect();
      this.#observer = null;
      clearTimeout(this.#settleTimer);
    }
  }

  if (!customElements.get('wce-carousel-guard')) {
    customElements.define('wce-carousel-guard', WceCarouselGuard);
  }
  } catch(e) { console.error(e); }
})();

})();
